{
  "point": "point",
  "points": "points",
  "credits": "credits",
  "loyaltyCredit": "Loyalty Credit",
  "statusPoints": "Status Points",
  "balancePoints": "Points to Spend",

  "edit": "Edit",
  "delete": "Delete",
  "copyOf": "Copy of {value}",
  "numberedCopyOf": "Copy {index} of {value}",
  "total": "total",
  "uplift": "uplift",

  "approveBtn.label": "Ok",
  "cancelBtn.label": "Cancel",
  "createBtn.label": "Create",
  "saveBtn.label": "Save",
  "searchBtn.label": "Search",
  "updateBtn.label": "Update",
  "applyBtn.label": "Apply",
  "addNewPlanBtn.label": "Add Plan",
  "launchPlanBtn.label": "Launch Plan",
  "toOverviewBtn.label": "Go to Overview",
  "collapseBtn.label": "Collapse",
  "extendBtn.label": "Details ",
  "updateAndSave.label": "Update and Save",
  "pleaseConfirmBtn.label": "Confirm",
  "closeBtn.label": "Close",
  "resetBtn.label": "Reset",
  "confirmBtn.label": "Confirm",

  "status.inactive": "Inactive",
  "status.active": "Active",
  "status.deactivated": "Deactivated",
  "status.scheduled": "Scheduled",
  "status.expired": "Expired",
  "status.readyToUse": "Ready to Use",
  "status.readyToLaunch": "Ready to Launch",
  "status.empty": "Empty",

  "status.activity.pending": "Pending",
  "status.activity.confirmed": "Confirmed",
  "status.activity.expired": "Expired",
  "status.activity.canceled": "Canceled",
  "status.activity.removed": "Removed",

  "status.default": "Default",
  "action.promotion": "Promotion",
  "action.referral": "Referral",
  "action.action": "Action",

  "tiers.numberOfPurchases.plural.zero": "{number} purchases",
  "tiers.numberOfPurchases.plural.one": "{number} purchase",
  "tiers.numberOfPurchases.plural.two": "{number} purchases",
  "tiers.numberOfPurchases.plural.few": "{number} purchases",
  "tiers.numberOfPurchases.plural.many": "{number} purchases",
  "tiers.numberOfPurchases.plural.other": "{number} purchases",

  "validity.unlimited": "Unlimited",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} days",
  "validity.limitedFromEarn.value.days.plural.one": "{number} day",
  "validity.limitedFromEarn.value.days.plural.two": "{number} days",
  "validity.limitedFromEarn.value.days.plural.few": "{number} days",
  "validity.limitedFromEarn.value.days.plural.many": "{number} days",
  "validity.limitedFromEarn.value.days.plural.other": "{number} days",

  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} weeks",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} week",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} weeks",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} weeks",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} weeks",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} weeks",

  "validity.limitedFromEarn.value.months.plural.zero": "{number} months",
  "validity.limitedFromEarn.value.months.plural.one": "{number} month",
  "validity.limitedFromEarn.value.months.plural.two": "{number} months",
  "validity.limitedFromEarn.value.months.plural.few": "{number} months",
  "validity.limitedFromEarn.value.months.plural.many": "{number} months",
  "validity.limitedFromEarn.value.months.plural.other": "{number} months",

  "days": "Days",
  "dayInMonth": "Day",
  "month": "Month",
  "months.1": "January",
  "months.2": "February",
  "months.3": "March",
  "months.4": "April",
  "months.5": "May",
  "months.6": "June",
  "months.7": "July",
  "months.8": "August",
  "months.9": "September",
  "months.10": "October",
  "months.11": "November",
  "months.12": "December",

  "form.missingSettingsAlert": "Make sure you enter all required information before you save and continue to the next step.",
  "noResults.title": "No results found.",
  "noResults.text": "There are no matching results for your search \"{text}\".",

  "alertContainer.editModeAlert.message": "You're editing the next version of your Loyalty plan. Your changes take effect after you launch this new version. ",
  "alertContainer.liveModeAlert.message.linkText": "Learn More",
  "alertContainer.liveModeAlert.message": "To edit Tiers, Fixed, and Additional Benefits, from Loyalty Management, select Update and Launch, then switch to Edit next version. {link}",
  "card.isRoadmap.text": "Roadmap",
  "catalogSelector.tooManyResults.title": "There are too many results for this search. ",
  "catalogSelector.tooManyResults.text": "Try your search again with more specific keywords to narrow your results.",
  "catalogSelector.errorAlert": "Something went wrong. Please try again.",
  "catalogSelector.searchPlaceholder.byItem": "Search for a specific product.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Select specific brands or categories you want to promote.",
  "catalogSelector.checkAllItems.label": "Select All",
  "catalogSelector.showAllSelections.label": "Show only the selected items.",
  "catalogSelector.cancelBtn.label": "Close",
  "catalogSelector.saveBtn.label": "Apply and Save",

  "catalogSelector.brands.plural.zero": "{number} brands",
  "catalogSelector.brands.plural.one": "{number} brand",
  "catalogSelector.brands.plural.two": "{number} brands",
  "catalogSelector.brands.plural.few": "{number} brands",
  "catalogSelector.brands.plural.many": "{number} brands",
  "catalogSelector.brands.plural.other": "{number} brands",
  "catalogSelector.category.plural.zero": "{number} categories",
  "catalogSelector.category.plural.one": "{number} category",
  "catalogSelector.category.plural.two": "{number} categories",
  "catalogSelector.category.plural.few": "{number} categories",
  "catalogSelector.category.plural.many": "{number} categories",
  "catalogSelector.category.plural.other": "{number} categories",
  "catalogSelector.product.plural.zero": "{number} products",
  "catalogSelector.product.plural.one": "{number} product",
  "catalogSelector.product.plural.two": "{number} products",
  "catalogSelector.product.plural.few": "{number} products",
  "catalogSelector.product.plural.many": "{number} products",
  "catalogSelector.product.plural.other": "{number} products",

  "confirmNavDialog.discardChanges.text": "Be sure to save your changes. If you leave this page, any unsaved changes will be lost.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Cancel",
  "actionDashboard.overviewLinkText.referral": "Go to Referral Actions",
  "actionDashboard.editLinkText": "Edit Program",
  "dashboardOptions.launchedAt": "Program launched on: ",
  "dashboardOptions.currentlyShowingLabel": "Currently Showing:",
  "dashboardOptions.viewLabel": "View:",
  "masterActions.join.largeText": "Join Loyalty",
  "masterActions.purchases.largeText": "Purchase",

  "status.inactive.tooltip": "The settings have not been completed.",
  "status.inactive.tooltip.proomotionEnded": "This promotion is inactive and can't be edited. You can copy the promotion or create a new one.",
  "status.inactive.tooltip.connectedToRewardPools": "Voucher pool {name} has the status {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Check the promotion dates.",
  "status.readyToUse.tooltip.promotion": "The promotion is ready to use. You can automatically display the promotion in the member's Wallet or attach to members in the Campaign Editor using Loyalty tokens.",
  "status.readyToUse.tooltip.attachable": "The action is ready to use and can be attached to contacts via campaign editor using the loyalty tokens.",
  "status.active.tooltip.promotion": "This promotion is active and available to your members.",
  "status.active.tooltip.attachable": "This action is active. You can't change the settings. To edit this action, first deactivate it and wait for the specified expiration date. You can also copy the action, edit the copy, and launch the copy as a new action.",
  "status.active.tooltip.event": "This action is active. You can connect the action to benefits or automation program.",
  "status.deactivated.tooltip.promotion": "You deactivated this promotion and it is no longer available to members.",
  "status.deactivated.tooltip.attachable": "You deactivated this action. To edit or delete this action, you have to wait for the specified expiration date. You can also can copy the action, edit the copy, and launch the copy as a new action.",
  "editorTypePopup.title": "Select Editor Type",
  "editorTypePopup.text": "Customers without exclusive access will see a blocking page. You can create a custom HTML page or use one of our templates.",
  "editorTypePopup.options.html.text": "Create Custom HTML Page",
  "editorTypePopup.options.template.text": "Create Page from Template",
  "fileInputField.uploadBtn.label": "Upload",
  "fileInputField.browseBtn.label": "Browse",
  "formStepsContainer.nextStep.text": "Next Step",
  "formStepsContainer.prevStep.text": "Previous Step",

  "iconGallery.title": "Loyalty Icon Gallery",
  "iconGallery.deleteDialog.headline": "Are you sure you want to delete this icon?",
  "iconGallery.deleteDialog.content": "After you delete this icon, it won't be visible to members. Make sure this icon is not connected to any action or Voucher.",
  "iconGallery.uploadResult.successMessage": "Upload successful.",
  "iconGallery.searchInput.placeholder": "Search for icon by name.",
  "iconGallery.fileUploader.tooltip": "<h3>Upload</h3><b>Icon upload requirements:</b></br>File: SVG or PNG</br>Format: Square<br>Max dimentions: 200x200 pixels <br>Max file size: 100 KB</br><sub>* We recommend a transparent background </sub>.",
  "multiLangPopup.defaultNoticeText": "Your defined primary language is the default language members see, if there are no suitable language settings.",
  "multiLangPopup.defaultTitle.currency": "Currency Translation",
  "multiLangPopup.defaultTitle.language": "Language Translation",
  "multiMarketSelector.multiSelectField.placeholder": "-- Select markets --",
  "multiMarketSelector.selectField.placeholder": "-- Select market --",
  "multiPlanSelect.label": "Select Your Loyalty Plan ",
  "preLaunchPopup.conditions.plan.title": "Plan Settings",
  "preLaunchPopup.conditions.plan.text": "Check your Loyalty plan settings to make sure everything is set up properly and match the terms for members.",
  "preLaunchPopup.conditions.tiers.title": "Tiers and Benefits",
  "preLaunchPopup.conditions.tiers.text": "Check that your tiers are set up properly for all your members and that your contact distribution in the tiers match your strategy.",
  "preLaunchPopup.conditions.rewards.title": "Rewards Pools",
  "preLaunchPopup.conditions.rewards.text": "Check that you uploaded enough Vouchers codes for all responses and that all pools and Vouchers validity is defined correctly.",
  "preLaunchPopup.conditions.actions.title": "Actions",
  "preLaunchPopup.conditions.actions.text": "Check that your actions cover all tactics you want to use and that you activated all default actions.",
  "preLaunchPopup.title": "Are you sure you want to launch your Loyalty plan?",
  "preLaunchPopup.text": "Check your settings to make sure your Loyalty plan is ready to launch:",
  "timeValidityInput.radioLabel.days": "Days",
  "timeValidityInput.radioLabel.weeks": "Weeks",
  "timeValidityInput.radioLabel.months": "Months",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA text",
  "message": "Message",

  "pageNotFound": "We can't seem to find the page you're looking for.",
  "externalEventSetup.title": "External Loyalty Event",
  "externalEventSetup.name.label": "External Event Name",
  "externalEventSetup.description.label": "Description",
  "externalEventSetup.description.tooltip": "A description is internal and helps you manage your Loyalty events.",

  "pointsRatesFields.perDescriptor.points": "earned per",

  "catalog.item.type.category.name": "Category",
  "catalog.item.type.brand.name": "Brand",
  "catalog.item.type.item.name": "Product",
  "catalog.item.type.itemId.name": "Item ID",

  "exclusiveAccessOffers.options.fixedBenefit.title": "Access as a Fixed Benefit",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Access as an Additional Benefit",
  "exclusiveAccessOffers.options.action.title": "Access as an Action Reward",
  "exclusiveAccessOffers.options.redemption.title": "Access for Points",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Access for Free",
  "accessValidityType.options.unlimited.name": "Access is valid for an unlimited time period.",
  "accessValidityType.options.limitedFromEarn.name": "Access is valid for a limited time period starting when the member earns it.",
  "accessValidityType.options.fixedDate.name": "Access is valid for a predefined time period for all members.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Disable access availability as a fixed benefit.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Disable access availability as an additional benefit.",
  "accessValidityType.options.disabled.reward.name": "Disable access availability as a reward for action.",
  "createOfModify.options.create.name": "Activate Offer",
  "createOfModify.options.create.tooltip": "When you activate a new offer, the active offer rules are reset and are available to members of all the selected tiers for the defined offer time period.",
  "createOfModify.options.create.tooltip2": "When you activate a new offer, the active offer restrictions are reset and are available to members of all the selected tiers for the defined offer time period. ",
  "createOfModify.options.modify.name": "Edit Active Offer",
  "createOfModify.options.modify.tooltip": "When you edit an active offer, your changes do not affect members that already redeemed this offer.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Exclusivity Settings",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Blocking Page",
  "exclusiveAccessFormSteps.redemptionValue.title": "Access and Offers",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Activation",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} to spend",
  "activityElementPointsText.status": "Status {{points_name}}",
  "activityElementPointsText.cashback": "Cashback",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Single-Use Voucher",
  "voucherTypeText.yearly": "Multi-Use Voucher",
  "exclusiveAccessTypeText.permanent": "Permanent Exclusive Access",
  "exclusiveAccessTypeText.limitedTerm": "Limited Time Exclusive Access",

  "mainTabs.dashboard.title": "Dashboard",
  "mainTabs.actions.title": "Actions",
  "mainTabs.rewards.title": "Rewards",
  "mainTabs.tiers.title": "Tiers",
  "mainTabs.loyaltyWallet.title": "Loyalty Wallet",
  "mainTabs.memberProfiles.title": "Member Profiles",
  "mainTabs.externalEvents.title": "External Events",
  "mainTabs.planSettings.title": "Plan Settings",
  "mainTabs.vouchers.title": "Vouchers",
  "mainTabs.exclusiveAccesss.title": "Exclusive Access",
  "mainTabs.loyaltyManagement.title": "Loyalty Management",
  "mainTabs.security.title": "Loyalty Configurations",

  "actionTabs.purchases.title": "Purchases",
  "actionTabs.promotions.title": "Promotions",
  "actionTabs.engagements.title": "Engagement",
  "actionTabs.events.title": "Events",
  "actionTabs.referral.title": "Referral",
  "actionTabs.join.title": "Join Loyalty",
  "tierTabs.tiers.title": "Tiers",
  "tierTabs.fixedBenefits.title": "Fixed Benefits",
  "tierTabs.additionalBenefits.title": "Additional Benefits",
  "tierTabs.contactDistribution.title": "Distribution Chart",
  "managementTabs.accountSettings.title": "Account Settings",
  "managementTabs.languageAndCurrency.title": "Language and Currency",
  "managementTabs.planSettings.title": "Plan Settings",
  "managementTabs.cashbackSettings.title": "Cashback Settings",
  "managementTabs.membershipSettings.title": "Membership Settings",
  "managementTabs.updateAndLaunch.title": "Update and Launch",
  "onboardingTabs.accountSettings.title": "Plan Creation",
  "onboardingTabs.activation.title": "Activation",
  "customerCalcPeriod.options.1.name": "Last 30 days",
  "customerCalcPeriod.options.2.name": "Last 60 days",
  "customerCalcPeriod.options.3.name": "Last 90 days",
  "customerCalcPeriod.options.6.name": "Last 6 Months",
  "customerCalcPeriod.options.12.name": "Last 12 Months",
  "planType.options.points.name": "Points and Redemption",
  "planType.options.points_and_benefits.name": "Points and Benefits",
  "planType.options.spend.name": "Spend and Benefits",
  "planType.options.points.tooltip": "Points-based plan with single or multiple tiers and points redemption.",
  "planType.options.points_and_benefits.tooltip": "Points-based plan with multiple tiers and benefits without points redemption.",
  "planType.options.spend.tooltip": "Spend-based plan with single or multiple tiers and benefits without points, but with cashback option rules. Only one currency is managed in a spend-based plan. If you manage multiple currencies, you need to manage a separate plan for each currency.",
  "pointsAllocatopmDelay.options.1.name": "24 Hours",
  "pointsAllocatopmDelay.options.2.name": "48 Hours",
  "pointsAllocatopmDelay.options.3.name": "72 Hours",
  "pointsAllocatopmDelay.options.7.name": "7 Days",
  "pointsAllocatopmDelay.options.14.name": "14 Days",
  "pointsAllocatopmDelay.options.21.name": "21 Days",
  "pointsAllocatopmDelay.options.30.name": "30 Days",
  "pointsAllocatopmDelay.options.40.name": "40 Days",
  "tierCalculationType.options.endOfYear.name": " Tier calculation occurs on December 31st every [X years].",
  "tierCalculationType.options.endOfYear.tooltip": "Tiers are calculated on a fixed date, every [x years]. Members that are upgraded to a higher tier keep their tier status for the defined period.",
  "tierCalculationType.options.afterJoin.name": "Tier calculation is done [X months] from the date the member enters a tier.",
  "tierCalculationType.options.afterJoin.tooltip": "Tier calculation date can vary depending on the member's progress through the tiers. Members that are upgraded to a higher tier keep their tier status at least for the defined period.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "When the tier is calculated, the Loyalty credit is reset, but members keep their tier status until the next calculation.",
  "tierCalculationType.options.noDropout.name": "Tiers are not calculated. Members don't need to meet requirements to stay in this tier.",
  "tierCalculationType.options.noDropout.tooltip": "Points are collected only for upgrading tiers.",
  "statusPointsExpirationType.options.tierCalc.name": "Status points expire and reset on the tier calculation date.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "When points are calculated, they are reset, but members keep their tier status until the next calculation.",
  "statusPointsExpirationType.options.fromEarn.name": "Status points expire and are reset every [X months] from the date the member earns the points.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "When tiers are calculated, only the valid points for that day are calculated. Members keep their status or drop down to a lower tier.",
  "statusPointsExpirationType.options.never.name": "Status points never expire.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Loyalty credit expires and is reset on the date tiers are calculated.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "When Loyalty credit is calculated, it is reset, but members keep their tier status until the next calculation.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Loyalty credit expires and is reset every [X months] from the date the member earns the credit.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "When tiers are calculated, only the valid Loyalty credit for that day is calculated. Members keep their status or drop down to a lower tier.",
  "optIn.options.invitation.name": "All contacts are invited to join the Loyalty plan.",
  "optIn.options.automatic.name": "All contacts automatically become Loyalty members.",
  "historicalBalancePoints.options.keep.name": "Reward with Spend Points.",
  "historicalBalancePoints.options.keep.tooltip": "This option incentivizes members to redeem points for rewards.",
  "historicalBalancePoints.options.remove.name": "Do not reward with Spend Points.",
  "historicalBalancePoints.options.remove.tooltip": "Spend Points are reset and members must earn new points to redeem.",
  "currencyIdentifierSigh.options.symbol.name": "Currency Symbol",
  "currencyIdentifierSigh.options.symbol.tooltip": "Example: $500",
  "currencyIdentifierSigh.options.code.name": "ISO Currency Code",
  "currencyIdentifierSigh.options.code.tooltip": "Example: 500USD",
  "currencyIdentifierSigh.options.none.name": "Without Identifier",

  "formStepRewards.options.poolSettings.title": "Pool Settings",
  "formStepRewards.options.uploadFile.title": "Upload File",
  "formStepRewards.options.redemptionValue.title": "Offer Settings",
  "formStepRewards.options.validity.title": "Validity",
  "specialTiers.redemptopmSettings.all.name": "Use the same settings for all tiers. Individual tier values are overridden.",
  "voucherValidityType.options.unlimited.name": "Voucher is valid for an unlimited time period.",
  "voucherValidityType.options.limitedFromEarn.name": "Voucher is valid for a limited time period from when the member earns the Voucher.",
  "voucherValidityType.options.fixedDate.name": "Voucher is valid for a predefined time period for all members.",
  "redemptionLimit.options.noLimit.name": "Automatically show this offer to members on a regular basis.",
  "redemptionLimit.options.noLimit.tooltip": "If you enable the toggle for a tier, the redemption offer is shown in the Loyalty Wallet without redemption restrictions.",
  "redemptionLimit.options.limitMember.name": "Select how many times each member can redeem a Voucher during the defined time period for this offer.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Permanent Exclusivity",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Limited-Term Exclusivity",
  "exclusiveAccessExclusivityType.options.name.limited": "Limited Exclusivity",

  "editorContentTextDefaultValues.tag": "Exclusive Access",
  "editorContentTextDefaultValues.firstHeader": "<strong>Early Black Friday</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>SALE</strong>",
  "editorContentTextDefaultValues.middleText": "Exclusive Black Friday deals for our loyal members. Don't miss out. Join the Loyalty plan now!",
  "editorContentTextDefaultValues.actionTopText": "Not a member yet? Join our Loyalty plan and start earning rewards.",
  "editorContentTextDefaultValues.leftButton": "Join Loyalty",
  "editorContentTextDefaultValues.rightButton": "Another Time",
  "editorContentTextDefaultValues.actionBottomText": "<span>Already a member? <u>Sign in</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Exclusive deals for our loyal customers. Don't miss the out. Join our Loyalty plan now!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Not a member yet? Join our Loyalty program.",
  "accessUrlType.options.exactUrl.name": "Block and offer exclusive access to this page:",
  "accessUrlType.options.startsWithUrl.name": "Block and offer exclusive access to all pages that start with this URL:",
  "formStepsContainer.tierSettings.title": "Tier Settings",
  "formStepsContainer.purchaseBenefits.title": "Purchase Benefits",
  "formStepsContainer.visibility.title": "Visibility",
  "tierDropout.options.yes.name": "Yes, this tier is calculated and members must meet the requirements to stay in this tier.",
  "tierDropout.options.no.name": "No, there is no dropout scenario from this tier.",
  "fixedBenfitType.options.oneTimeVoucher.name": "One Time Voucher",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Fixed Yearly Voucher (multi-use code is required).",
  "fixedBenfitType.options.eventAction.name": "Event",
  "fixedBenfitType.options.exclusiveAccess.name": "Exclusive Access",
  "fixedBenfitType.options.custom.name": "Custom (provided independently by you)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Multi-Use Voucher (multi-use code is required).",
  "tierTypeOptions.regular.name": "Points-Based",
  "tierTypeOptions.invite.name": "Invitation Only",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Learn more",
  "tierTypeOptions.invite.tooltip": "Only invited or paying members can belong to the tier. Manage payment and membership on your side. To add a member to this tier, use the Loyalty API or Member Profiles. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Spend-Based",
  "exclusiveAccess.cardLabels.permanent": "Permanent",
  "exclusiveAccess.cardLabels.limtedTerm": "Limited-Term",

  "cards.filterBar.moreFiltersButton": "More Filters",

  "catalogSelector.selected.single": "{items} selected",
  "catalogSelector.selected.multiple": "{items} and {lastItems} selected",
  "iconGallery.uploadResult.failMessage": "Something went wrong during the upload. Be sure the files meet the requirements. \n{showFileList,select,true{{failed} out of {total} failed: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "for every",
  "activityElementMultiuplyPointsText.double": "Double",
  "activityElementMultiuplyPointsText.triple": "Triple"
}
